export default "__VITE_ASSET__IaX0dpGC__"